export const UPDATE_SEARCH_STRING = 'UPDATE_SEARCH_STRING'
export const UPDATE_PAGES = 'UPDATE_PAGES'


export function updateSearchString(searchString) {
  return {
    type: UPDATE_SEARCH_STRING,
    searchString
  }
}

export function updatePages(pages) {
  return {
    type: UPDATE_PAGES,
    pages
  }
}


// WEBPACK FOOTER //
// ./src/state/actions.js